export { default as isCEP } from './isCEP';
export { default as isCNPJ } from './isCNPJ';
export { default as isCPF } from './isCPF';
export { default as isPhone } from './isPhone';
